import { z } from 'zod/v4';
import { EConfigurationChannel } from '../cms/configuration/configuration.enums';

export interface IFellowTravelerDto {
  id?: string;
  salutation?: string | null;
  firstName: string;
  lastName: string;
  dateOfBirth?: string | null;
}

export interface IFellowTravelerBulkRequest {
  authHeader: string;
  clientChannel: EConfigurationChannel;
  fellowTravelers: IFellowTravelerDto[];
}

export const FELLOW_TRAVELER_SCHEMA: z.ZodType<IFellowTravelerDto> = z.object({
  id: z.uuid(),
  salutation: z.string().nullable().optional(),
  firstName: z.string(),
  lastName: z.string(),
  dateOfBirth: z.string().nullable().optional(),
});

export const FELLOW_TRAVELERS_SCHEMA: z.ZodType<IFellowTravelerDto[]> = z.array(
  FELLOW_TRAVELER_SCHEMA
);
